// Runtime configuration service
// Fetches configuration from /.config.json at app startup
// This prevents configuration from being baked into JavaScript bundles

let runtimeConfig = null;
let configPromise = null;

/**
 * Fetch runtime configuration from /.config.json
 * Returns cached config if already loaded
 */
export async function getConfig() {
  if (runtimeConfig) {
    return runtimeConfig;
  }

  if (!configPromise) {
    configPromise = fetch('/.config.json')
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to load config: ${response.status}`);
        }
        return response.json();
      })
      .then(config => {
        console.log('[Config] Runtime configuration loaded successfully');
        runtimeConfig = config;
        return config;
      })
      .catch(error => {
        console.error('[Config] Failed to load runtime configuration:', error);
        // Fallback to environment variables (for backward compatibility)
        runtimeConfig = {
          instanceId: process.env.REACT_APP_INSTANCE_ID,
          bucketName: process.env.REACT_APP_BUCKET_NAME,
          appName: process.env.REACT_APP_APP_NAME || '3CX Recordings',
          apiUrl: process.env.REACT_APP_API_URL,
          azureTenantId: process.env.REACT_APP_AZURE_TENANT_ID,
          azureClientId: process.env.REACT_APP_AZURE_CLIENT_ID,
          azureRedirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin,
        };
        return runtimeConfig;
      });
  }

  return configPromise;
}

/**
 * Get config value synchronously (only works after config has been loaded)
 * Use getConfig() if you need to ensure config is loaded first
 */
export function getConfigSync() {
  if (!runtimeConfig) {
    throw new Error('Config not loaded yet. Call getConfig() first and await the result.');
  }
  return runtimeConfig;
}
